import React from 'react';
export function Testimonials() {
  const testimonials = [{
    quote: 'At the Silicon Valley Leadership Group we are focused on catalyzing change around diversity, equity, and inclusion, from the boardroom to the C-suites and beyond. Applied Wisdom for the Nonprofit Sector helps to inform both our practice and structured execution on this key business imperative.',
    author: 'Ahmad Thomas',
    title: 'CEO, Silicon Valley Leadership Group',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jEz28xrQZL3GY1HsPup91q/image.png'
  }, {
    quote: 'At CEN, we see the potential for every team member, regardless of title, to show up as a leader. In our programming, Applied Wisdom for the Nonprofit Sector has served as a great tool to aid any and every one in improving their leadership and management skills.',
    author: 'Shana Peete',
    title: 'Chief Executive Officer, Center for Excellence in Nonprofits',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jgyabxvMuJxXgbBkUNTxgp/image.png'
  }, {
    quote: "In my online course I have my students read and discuss Applied Wisdom for the Nonprofit Sector. It's packed with insightful leadership principles and common sense. My students love the book and the relevant wisdom they glean for their future nonprofit leadership careers!",
    author: 'Brad McMillan',
    title: 'Executive Director, Institute for Principled Leadership in Public Service, Bradley University',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vBwraE4BJUYjfVjyLJYykX/image.png'
  }];
  return <section className="py-16 px-6 bg-white" data-id="element-124">
      <div className="max-w-6xl mx-auto" data-id="element-125">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#E85C41] mb-12" data-id="element-126">
          Testimonials
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-127">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#FFE8E0] p-8 rounded-lg flex flex-col h-full" data-id="element-128">
              <p className="text-gray-700 mb-8 flex-grow leading-relaxed" data-id="element-129">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-130">
                <img src={testimonial.image} alt={testimonial.author} className="w-16 h-16 rounded-full object-cover border-2 border-[#E85C41]" data-id="element-131" />
                <div data-id="element-132">
                  <p className="font-semibold text-[#E85C41] text-lg" data-id="element-133">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-134">{testimonial.title}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}